module.exports = __webpack_public_path__ + "static/media/zoom-in.ac447e05.svg";